import { Accordion, Divider } from '../../designComponents';
import {
  JobInformation,
  PrintingAndPdfInformation,
  PropertyInformation,
  UserInformationHorizontal,
} from './index';

const EvaluationPlanForLocation = ({ location }: { location: string }) => {
  return (
    <Accordion
      items={[
        {
          key: '1',
          content: (
            <div>
              <JobInformation
                jobCreatedAt="12 aug 2023 - 12:59 am"
                jobTitle="12 aug 2023 - 12:59 am"
                notes="Lorem ipsum dolor sit amet consectetur. Mi ultricies mollis magna cursus libero. Lacus sodales gravida vulputate id suspendisse magna iaculis. Eget et et enim facilisi amet ac eget. Faucibus gravida risus massa aliquam vitae. Adipiscing pretium dignissim vestibulum non netus ultricies. Morbi sit sed sed vulputate pretium dolor dictum eget."
              />
              <Divider spaceY="20px" />
              <PropertyInformation
                buildingId="1"
                buildingName="Bhaktapur Mall"
                addressOfProperty="Radhe Radhe, Bhaktapur"
              />
              <Divider spaceY="20px" />
              <UserInformationHorizontal
                user="client"
                userName="Nitish Rajak"
                email="NitishRajak12@gmail.com"
              />
              <Divider spaceY="20px" />
              <UserInformationHorizontal
                user="Technical"
                userName="Nitish Rajak"
                email="NitishRajak12@gmail.com"
              />
              <Divider spaceY="20px" />
              <PrintingAndPdfInformation pdfRecrearteCount="0" quantity="1" />
            </div>
          ),
          title: `EVACUATION PLAN FOR ${location.toUpperCase()}`,
          titleFontVariant: 'title',
          fontColor: 'secondary',
        },
      ]}
    />
  );
};

export default EvaluationPlanForLocation;
